import { connect } from 'react-redux';
import { withI18n } from 'react-i18next';
import { withRouter } from 'react-router';

import HeaderBanner from './HeaderBanner';

import { IInitialState } from 'src/store/initialState';
import { accountSpecialUserSel, userDataSel } from 'src/store/modules/user';
import { signInActions, accountHasChangedSel } from 'src/store/modules/signin';

const mapStateToProps = (state: IInitialState) => ({
  specialUser: accountSpecialUserSel(state),
  userData: userDataSel(state),
  accountHasChanged: accountHasChangedSel(state)
});

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  changeActiveAccountFlag: (flag: boolean) =>
    dispatch(signInActions.activeAccountHasChanged(flag)),
  changeActiveAccount: (newAccountId: string, clientIdentity: string) =>
    dispatch(signInActions.changeActiveAccount(newAccountId, clientIdentity))
});

export const pureComponent = HeaderBanner;
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(withRouter(HeaderBanner as any)));

interface IDispatchFromProps {
  changeActiveAccountFlag(flag: boolean): void;
  changeActiveAccount(newAccountId: string, clientIdentity: string): void;
}
